import { ssmRouterGuardService } from "@/shared/services/router-guard-service";
import Vue from "vue";
import Router from "vue-router";
import { RouterNames } from "./routernames";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/main",
    },
    {
      path: "*",
      redirect: "/main",
    },
    {
      path: "/login",
      name: RouterNames.Login,
      component: () => import("@/views/login/login-formulario.vue"),
    },
    {
      path: "/lostpwd",
      name: RouterNames.lostpwd,
      component: () => import("@/views/lostpwdforms/pswlost.vue"),
    },
    {
      path: "/confirm-new-password/:token",
      name: RouterNames.confirm_new_password,
      component: () => import("@/views/lostpwdforms/pwdlost-confirm.vue"),
    },
    {
      path: "/instalacion",
      name: RouterNames.instalacion,
      component: () => import("@/views/instalacion/instalacion.vue"),
    },
    {
      path: "/mainlayout",
      name: RouterNames.main,
      component: () => import("@/components/titulopantalla/titulo.vue"),
      children: [
        {
          path: "otp",
          name: RouterNames.otp,
          component: () =>
            import("@/views/layout/main-layout-base.vue"),
          children: [
            {
              path: "/iniciar-otp",
              name: RouterNames.configurarotp,
              component: () => import("@/views/Otp/AuthOtp.vue"),
            },
            {
              path: "/logear-otp",
              name: RouterNames.logearotp,
              component: () => import("@/views/Otp/LogearOtp.vue"),
            },

          ],
        },
      ],
    },
    {
      path: "/main",
      redirect: "/main/home",
      name: RouterNames.mainlayout,
      component: () => import("@/views/mainlayout/main-layout.vue"),
      beforeEnter: ssmRouterGuardService.beforeEnter,
      children: [
        {
          path: "home",
          name: RouterNames.Home,
          component: () =>
            import("@/views/Administrador/CitasDashboard.vue"),
        },
        {
          path: "components-demo",
          name: "ComponentsDemo",
          component: () => import("@/views/demo/ComponentsDemo.vue"),
        },
        {
          path: "calendar-demo",
          name: "CalendarDemo",
          component: () => import("@/views/demo/CalendarDemo.vue"),
        },
        {
          path: "kanban-demo",
          name: "KanbanDemo",
          component: () => import("@/views/demo/KanbanDemo.vue"),
        },
        {
          path: "tablas",
          name: RouterNames.tablas_test,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tabla/:id",
              name: RouterNames.table,
              component: () =>
                import("@/views/dynamic_tables/full_dynamic_table.vue"),
            },
            {
              path: "dxtabla/:id",
              name: RouterNames.dxtable,
              component: () =>
                import("@/components/DataTableGenerico/DxFullDataTable.vue"),
            },
          ],
        },
        {
          path: "tbkn",
          name: RouterNames.tbkn,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tbkn/:id",
              name: RouterNames.viewtbkn,
              component: () =>
                import("@/views/dynamic_views/dynamic_change_views.vue"),
            },
          ],
        },
        {
          path: "kanban",
          name: RouterNames.kanban,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "kanban/:id",
              name: RouterNames.viewKanban,
              component: () => import("@/views/dynamickanban/ViewKanban.vue"),
            },
          ],
        },
        {
          path: "enumeraciones",
          name: RouterNames.enumeraciones,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "enumeracion/:id_cabezera",
              name: RouterNames.enumeracion,
              component: () =>
                import("@/views/prioridades/GenericPrioridadesForm.vue"),
            },
          ],
        },
        {
          path: "administracion",
          name: RouterNames.administracion,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "usuarios",
              name: RouterNames.usuarios,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.usuarioslista,
                  component: () => import("@/views/usuarios/UsuariosLista.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.usuariosformulario,
                  component: () =>
                    import("@/views/usuarios/UsuariosFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "rol",
              name: RouterNames.rol,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.rollista,
                  component: () => import("@/views/roles/RolesLista.vue"),
                  children: [],
                },
                {
                  path: "formulario",
                  name: RouterNames.rolformulario,
                  component: () => import("@/views/roles/RolesFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "notificaciones/formulario",
              name: RouterNames.notificaciones,
              component: () =>
                import("@/views/notificaciones/NotificacionesForm.vue"),
            },
            {
              path: "datos_empresa/formulario/:id",
              name: RouterNames.datos_empresaformulario_empresa,
              component: () =>
                import("@/views/empresa/DatosEmpresaFormulario.vue"),
            },
            {
              path: "admin",
              name: RouterNames.admin,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "usuarios_plataforma_admin/:id",
                  name: RouterNames.usuarios_plataforma_admin,
                  component: () =>
                    import("@/views/Administrador/AdminUsuariosFormulario.vue"),
                  children: [],
                }, {
                  path: "active_users",
                  name: RouterNames.active_users,
                  component: () =>
                    import("@/views/Administrador/ActiveUsersDashboard.vue"),
                  children: [],
                }, {
                  path: "scheduled_tasks",
                  name: RouterNames.scheduled_tasks,
                  component: () =>
                    import("@/views/Administrador/ScheduledTasksViewer.vue"),
                  children: [],
                }, {
                  path: "centros",
                  name: RouterNames.centros_admin,
                  component: () =>
                    import("@/views/Administrador/CentrosManager.vue"),
                  children: [],
                }, {
                  path: "centros-servicios",
                  name: RouterNames.centros_servicios_admin,
                  component: () =>
                    import("@/views/Administrador/CentrosServiciosManager.vue"),
                  children: [],
                }, {
                  path: "canales-entrada",
                  name: RouterNames.canales_entrada_admin,
                  component: () =>
                    import("@/views/Administrador/CanalesEntradaManager.vue"),
                  children: [],
                }, {
                  path: "estados-cita",
                  name: RouterNames.estados_cita_admin,
                  component: () =>
                    import("@/views/Administrador/EstadosCitaManager.vue"),
                  children: [],
                }, {
                  path: "pacientes-leads",
                  name: RouterNames.pacientes_leads_admin,
                  component: () =>
                    import("@/views/Administrador/PacientesLeadsManager.vue"),
                  children: [],
                }, {
                  path: "solicitudes-cita",
                  name: RouterNames.solicitudes_cita_admin,
                  component: () =>
                    import("@/views/Administrador/SolicitudesCitaManager.vue"),
                  children: [],
                }, {
                  path: "solicitudes-cita-hist",
                  name: RouterNames.solicitudes_cita_estado_hist_admin,
                  component: () =>
                    import("@/views/Administrador/SolicitudesCitaEstadoHistManager.vue"),
                  children: [],
                }, {
                  path: "solicitudes-eventos-audit",
                  name: RouterNames.solicitudes_eventos_audit_admin,
                  component: () =>
                    import("@/views/Administrador/SolicitudesEventosAuditManager.vue"),
                  children: [],
                }, {
                  path: "public-agenda-test",
                  name: RouterNames.public_agenda_test_admin,
                  component: () =>
                    import("@/views/Administrador/PublicAgendaTest.vue"),
                  children: [],
                }, {
                  path: "public-agenda-wizard-test",
                  name: RouterNames.public_agenda_wizard_test_admin,
                  component: () =>
                    import("@/views/Administrador/PublicAgendaWizardTest.vue"),
                  children: [],
                },
                {
                  path: "citas-dashboard",
                  name: RouterNames.citas_dashboard_admin,
                  component: () =>
                    import("@/views/Administrador/CitasDashboard.vue"),
                  children: [],
                },
                {
                  path: "agenda-calendar",
                  name: RouterNames.agenda_calendar_admin,
                  component: () =>
                    import("@/views/Administrador/AgendaCalendarManager.vue"),
                  children: [],
                },
                {
                  path: "citas-edit-wizard-test",
                  name: RouterNames.citas_edit_wizard_test_admin,
                  component: () =>
                    import("@/views/Administrador/CitasEditWizardTest.vue"),
                  children: [],
                },
                {
                  path: "agents-admin",
                  name: RouterNames.agents_admin,
                  component: () =>
                    import("@/views/agents-admin/AgentsAdmin.vue"),
                  children: [],
                },
                {
                  path: "manychat-logs",
                  name: RouterNames.manychat_logs_admin,
                  component: () =>
                    import("@/views/Administrador/ManyChatLogsViewer.vue"),
                  children: [],
                },
                {
                  path: "cache-diagnostics",
                  name: RouterNames.cache_diagnostics_admin,
                  component: () =>
                    import("@/views/Administrador/CacheDiagnosticsViewer.vue"),
                  children: [],
                },
                {
                  path: "public-agenda-requests-log",
                  name: RouterNames.public_agenda_requests_log_admin,
                  component: () =>
                    import("@/views/Administrador/PublicAgendaRequestsLogViewer.vue"),
                  children: [],
                }
              ],
            },
          ],
        },
        {
          path: "plataforma",
          name: RouterNames.plataforma,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "instalacion/formulario",
              name: RouterNames.instalacion_plataforma,
              component: () => import("@/views/instalacion/instalacion.vue"),
            },
            {
              path: "menu-organizar",
              name: RouterNames.menu_plataforma_organizar,
              component: () =>
                import("@/views/plataforma/menu/MenuOrganizador.vue"),
            },
            {
              path: "menu",
              name: RouterNames.menu_plataforma,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.menu_plataforma_lista,
                  component: () =>
                    import("@/views/plataforma/menu/MenuLista.vue"),
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.menu_plataforma_formulario,
                  component: () =>
                    import("@/views/plataforma/menu/MenuFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "clientes",
              name: RouterNames.clientes,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.clientesformulario,
                  component: () =>
                    import("@/views/Clientes/clienteFormulario.vue"),
                  children: [],
                },
              ],
            }, {
              path: "permisos",
              name: RouterNames.permisos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "permisoslista",
                  name: RouterNames.permisoslista,
                  component: () =>
                    import("@/views/tables/table_editing.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "logs",
              name: RouterNames.logs,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.logsformulario,
                  component: () =>
                    import("@/views/plataforma/logs/logs_formulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "tablas",
              name: RouterNames.tablas,
              component: () =>
                import("@/components/titulopantalla/titulo-reactivo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.tablaslista,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_lista.vue"
                    ),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.tablasformulario,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_formulario.vue"
                    ),
                  children: [],
                },
              ],
            },
            {
              path: "version-control",
              name: "versioncontrol",
              component: () => import("@/views/Desarrollador/VersionControl.vue"),
            },
            {
              path: "systemlogs",
              name: "systemlogs",
              component: () => import("@/views/Desarrollador/LogsViewer.vue"),
            }, {
              path: "ip-rate-limiting",
              name: RouterNames.ipRateLimiting,
              component: () => import("@/views/Desarrollador/IpRateLimiting.vue"),
            },
            {
              path: "dynamic-form-builder",
              name: RouterNames.dynamic_form_builder,
              component: () =>
                import("@/components/titulopantalla/titulo-reactivo.vue"),
              children: [
                {
                  path: "form-builder-list",
                  name: "form_builder_list",
                  component: () => import("@/views/FormBuilder/FormBuilderList.vue"),
                },
                {
                  path: "form-builder",
                  name: RouterNames.form_builder,
                  component: () => import("@/views/FormBuilder/FormBuilderMain.vue"),
                },
                {
                  path: "form-builder-preview",
                  name: RouterNames.form_builder_preview,
                  component: () => import("@/views/FormBuilder/FormBuilderPreview.vue"),
                }, {
                  path: "form-builder-examples-clientes",
                  name: RouterNames.clientes_ejemplo,
                  component: () => import("@/views/FormBuilder/ejemplos/ClientesView.vue"),
                },]
            }
          ],
        },
        {
          path: "mi_perfil",
          name: RouterNames.mi_perfil,
          component: () => import("@/views/usuarios/MiPerfil.vue"),
        },
        {
          path: "cerrar_session",
          name: RouterNames.cerrar_session,
          component: () => import("@/views/cerrar_session.vue"),
          children: [],
        },
      ],
    },
  ],
});
